<template>
  <el-backtop :bottom="50" :right="50" :visibility-height="150">
    <img src="~@/assets/img/common/back-top.png" alt="">
  </el-backtop>
</template>
<script>
export default {}
</script>

<style scoped lang="scss">
.el-backtop {
  width: 68px;
  height: 68px;
  background-color: transparent;
  box-shadow: none !important;


  img {
    width: 68px;
    height: 68px;
  }
}
</style>
